export const CATEGORY_TYPE_CONCEPTUAL = 'Conceptual'; //table actions
